import { render, staticRenderFns } from "./JeecgOrderDMainList.vue?vue&type=template&id=1bacfb3c&scoped=true&"
import script from "./JeecgOrderDMainList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderDMainList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderDMainList.vue?vue&type=style&index=0&id=1bacfb3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacfb3c",
  null
  
)

export default component.exports